/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Pagination from "react-js-pagination";
import formatDateTimeToPST from "../PSTDateConvert";
import CarrierResponse from "./comman/CarrierResponse";
import CustomerStatusResponse from "./comman/CustomerStatusResponse";
import OrderDetailLog from "./comman/OrderDetailLog";
import OrderSummaryLog from "./comman/OrderSummaryDetail";
import OrderDetailFilter from "./comman/OrderDetailFilter";
import Loader from "../Loader";
import { saveAs } from 'file-saver';
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';
import { getOrderTypeLabel } from '../../utils/order';

 
const ViewOrderDetail = () => {
    const { id } = useParams();
    const [name, setName] = useState('');
    const [timeZone, seTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [orders, setOrders] = useState([]);
    const [error, setError] = useState(null);
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [numberManagementAccess, setNumberManagementAccess] = useState(true);
    const [detail, setDetail] = useState([]);
    const [orderSummary, setOrderSummary] = useState([]);
    const [allNumberList, setAllNumberList] = useState([]);
    const [filteredNumberList, setFilteredNumberList] = useState([]);
    const [dmtList, setDmtList] = useState([]);
    const [digitMapping, setDigitMapping] = useState(false);
    const [userDigitMapping, setUserDigitMapping] = useState(false);
    const [checkAdvanceDigitMapping, setCheckAdvanceDigitMapping] = useState(false);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);
    const [msg, setMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [manualStatus, setManualStatus] = useState('');
    const [portStatus, setPortStatus] = useState('')
    const [orderFilterData, setOrderFilterData] = useState({});
    const [carriers, setCarriers] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [reprocessing, setReprocessing] = useState(false);
    // BBD-416: confirmation prompt shown before a new order is put In Service when it still
    // carries Failed / Needs Review numbers. Null while no prompt is open.
    const [statusConfirm, setStatusConfirm] = useState(null);
    const [statusConfirmInput, setStatusConfirmInput] = useState('');

    // Helper to check if all selectable rows are selected. Uses the full (filtered)
    // number list so the "select all" checkbox covers every page of the order, not just the current page.
    // Conditions below must stay in sync with handleSelectAllChange, otherwise the
    // checkbox never turns checked after "select all" and cannot clear the selection.
    const selectableRows = detail?.order_type === 3
        ? (filteredNumberList || []).filter((order) => order.number_type >= 2 && order.user_status !== 3)
        : detail?.order_type === 8
        ? (filteredNumberList || []).filter((order) => order.user_status != 4 && order.user_status != 5)
        : (filteredNumberList || []).filter((order) => order.user_status != 1);
    const isAllSelected = selectableRows.length > 0 && selectedRows.length === selectableRows.length;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type');
    
    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
        getUserAccess();
        getOrderDetail(0);
    }, []);


    useEffect(() => {
        if(access.length > 0 && token){
            checkAccess(access, token);
        }
    }, [access, token, numberManagementAccess]);
    useEffect(() => {
        if(token){
            getCarrierList();
        }
    }, [token]);

    useEffect(() => {
        if(detail?.cid && detail?.order_type === 0){
            getCustomerDigitMappingAccess();
        }
    }, [detail]);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    const getCustomerDigitMappingAccess = async () => {
        try {
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${detail.cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            setDigitMapping(response.data.digit_mapping_switch === 1 ? true : false);
            setCheckAdvanceDigitMapping(role <= 2 || response.data.advance_digit_mapping_switch === 1 ? true : false);
            
        } catch (error) {
           console.log(error);
        }
    };

    const getCarrierList = async () => {
        // setPopupOpen(true);
        incrementLoading();
        const response = await axios.get(`${baseUrl}/carrier-settings?page=${page}&limit=${2000}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        // setPopupOpen(false);
        setCarriers(response.data.data);
        decrementLoading();
    }
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            setNumberManagementAccess(response.data.number_management_switch == 0 ? false : true);
            setUserDigitMapping(response.data.user_digit_mapping_switch == 0 ? false : true);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const handlePageChange  = (pageNumber) => {
        
        // setPopupOpen(true);
        incrementLoading();
        const limit = 20;
        const startIndex = (pageNumber - 1) * limit;
        const endIndex = pageNumber * limit;
    
        const slicedData = filteredNumberList?.slice(startIndex, endIndex);
        setOrders(slicedData);
        setPage(pageNumber);
        // setPopupOpen(false);
        decrementLoading();
    }
    const getOrderDetail = async (flag) => {
        // setPopupOpen(true);
        incrementLoading();
        const response = await axiosJWT.get(`${baseUrl}/order-detail/${atob(id)}?export=${flag}&orderFilterData=${JSON.stringify(orderFilterData)}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
       
        const data = response.data?.data?.[0]?.tn_details;
        const limit = 20; // Replace with your actual limit
        const startIndex = (page - 1) * limit;
        const endIndex = page * limit;
    
        const slicedData = data?.slice(startIndex, endIndex);
       
        
        
        setDetail(response.data?.data?.[0]);
        setAllNumberList(data);
        setFilteredNumberList(data);
        setDmtList([response.data.dmtList]);
        setOrderSummary(response.data.orderSummary);
        setSelectedValue(response.data?.data?.[0]?.order_status);
            if(flag == 1){
                handleExportCSV(data);
            }else{
                setOrders(slicedData);
            }
        
        setTotalItem(response.data?.data?.[0].tn_details.length);
        // setPopupOpen(false);
        decrementLoading();
    }
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };

    const checkAccess = async (access) => {
        if(!hasPermission('ordernewnumber') || !numberManagementAccess){
            navigate('/dashboard');
        }
    }

    const changeStatus = async(e) => {
        var orderStatus = e.target.value;
        setSelectedValue(orderStatus);               
        
    };

    // BBD-416: posts the status change once every gate for the order type has passed.
    // confirmFlags mirror what the user acknowledged in the UI so the backend can re-check them.
    const submitOrderStatusChange = async (confirmFlags = {}) => {
        try {
            const response = await axiosJWT.post(`${baseUrl}/order-status-change/${atob(id)}`, {
                order_status: selectedValue,
                order_type: detail.order_type,
                order_id: detail.id,
                ...confirmFlags
            },{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setIsSuccess(true);
            setMsg(response.data.msg);
            getOrderDetail(0); // Refresh data to show updated status and disable switch
        } catch (error) {
            setIsSuccess(false);
            setMsg(error.response?.data?.msg || 'Internal Server Error');
        }
    };

    // BBD-416: builds the "type YES" / "YES-NO" confirmation for a new order going In Service.
    // Failed numbers get the stricter typed gate, Needs Review alone only needs a click.
    const buildNewOrderInServiceConfirmation = (buckets) => {
        const reviewLanguage = "Please confirm that the numbers marked as 'Needs Review' have already been updated correctly in Sansay, NSS, the carrier portal, and any other required systems.";
        if (buckets.failed > 0) {
            const failedLanguage = `This order has ${buckets.failed} number${buckets.failed === 1 ? '' : 's'} that Failed.`;
            return {
                requireTypedYes: true,
                message: buckets.needsReview > 0 ? `${failedLanguage} ${reviewLanguage}` : failedLanguage,
                footer: 'Type YES to continue to put this order In Service.',
                confirmFlags: { confirm_failed: true, confirm_needs_review: buckets.needsReview > 0 }
            };
        }
        return {
            requireTypedYes: false,
            message: reviewLanguage,
            footer: 'Click Submit to change the order status, or Cancel to return to the order.',
            confirmFlags: { confirm_needs_review: true }
        };
    };

    const handleOrderStatusChange = async() => {
        try {
            let callApi = false;

            // BBD-416: a new order going In Service must not be signed off while the carrier
            // webhook is still outstanding, and the user has to acknowledge Failed / Needs Review
            // numbers instead of clicking straight past them. A Non-supported Carrier order is a new
            // order too, so it follows the same In Service flow.
            if((detail?.order_type == 0 || detail?.order_type == 6) && selectedValue == 0){
                const buckets = getNewOrderStatusBuckets(detail?.tn_details);
                if(buckets.inProgress > 0){
                    setIsSuccess(false);
                    setMsg(`This order still has ${buckets.inProgress} number${buckets.inProgress === 1 ? '' : 's'} In Progress. The carrier has not finished processing ${buckets.inProgress === 1 ? 'it' : 'them'} yet, so the order status cannot be changed until every number has completed.`);
                    return;
                }
                if(buckets.failed > 0 || buckets.needsReview > 0){
                    setStatusConfirm(buildNewOrderInServiceConfirmation(buckets));
                    setStatusConfirmInput('');
                    return;
                }
                await submitOrderStatusChange();
                return;
            }

            const supported = detail.tn_details.filter((item) => item.number_type == 1 || item.number_type == 0);
            const mixSupported = detail.tn_details.filter((item) => item.number_type >= 2 && (item.number_type == 1 || item.number_type == 0));
            let propmtMsg;
            if (mixSupported.length > 0) {
                // If there are mixed types (2 or more and any of 1 or 0)
                propmtMsg = "The number has been removed from the customer inventory and from the carrier, please confirm that it has been manually removed from the Sansay and Rome/NSS.The number has been removed from the customer inventory and from the Sansay, please confirm that it has been manually removed from the carrier and Rome/NSS.";
            } else if (supported.length > 0) {
                // If only 1 or 0
                propmtMsg = "The number has been removed from the customer inventory and from the carrier, please confirm that it has been manually removed from the Sansay and Rome/NSS.";
            } else {
                // If only 2 or more
                propmtMsg = "The number has been removed from the customer inventory and from the Sansay, please confirm that it has been manually removed from the carrier and Rome/NSS.";
            }
            
            const hasNonSupportedCarrier = detail.tn_details.some(item => item.number_type >= 2);
            const hasIncompleteAutoAction = detail.tn_details.some(item => item.sansay_status !== 1 || item.rome_status !== 1);
            const needsManualConfirmation = hasNonSupportedCarrier || hasIncompleteAutoAction;

            if(detail?.order_type == 2 && selectedValue == 1 && needsManualConfirmation){
                const userResponse = window.confirm(propmtMsg);
                if (userResponse) {
                    callApi = true;
                } else {
                    callApi = false;
                }
            }else{
                callApi = true;
            }
            if(callApi == true){
                await submitOrderStatusChange();
            }


        } catch (error) {
            setIsSuccess(false);
            setMsg(error.response?.data?.msg || 'Internal Server Error');
        }


    };

    // BBD-416: user typed YES (or clicked YES on the review-only prompt) - push the change through.
    const handleStatusConfirmAccept = async () => {
        if (statusConfirm?.requireTypedYes && statusConfirmInput.trim().toUpperCase() !== 'YES') {
            return;
        }
        const confirmFlags = statusConfirm?.confirmFlags || {};
        setStatusConfirm(null);
        setStatusConfirmInput('');
        await submitOrderStatusChange(confirmFlags);
    };

    const handleStatusConfirmCancel = () => {
        setStatusConfirm(null);
        setStatusConfirmInput('');
    };
 
    /**
     * BBD-419 — whether this order type supports a Sansay/ROME reprocess is decided
     * by the backend (`reprocess_supported` on the order detail response), so the
     * supported list lives in one place only.
     *
     * `tn_details` holds every number on the order, not just the current page, so a
     * "Needs Review" record on a later page still enables the button.
     */
    const hasNeedsReviewSansayRome = (detail?.tn_details || []).some(
        (item) => item.user_status != 3 && (item.sansay_status == 2 || item.rome_status == 2)
    );
    const canReprocessSansayRome =
        role <= 2 && detail?.reprocess_supported === true && hasNeedsReviewSansayRome;

    /**
     * Turns the per-leg backend result into one readable line for the status bar.
     */
    const buildReprocessMessage = (data) => {
        if (!data?.result) return data?.msg || "";
        const legs = ["sansay", "rome"]
            .filter((leg) => data.result[leg])
            .map((leg) => {
                const info = data.result[leg];
                const label = leg === "sansay" ? "Sansay" : "ROME";
                if (info.status === "skipped") return `${label}: skipped (${info.reason})`;
                const counts = info.failed > 0
                    ? ` — ${info.succeeded} recovered, ${info.failed} still need review`
                    : ` — ${info.succeeded} recovered`;
                return `${label}: ${info.status} on attempt ${info.attempt}${counts}`;
            });
        if (legs.length === 0) return data.msg || "Nothing to reprocess";
        return `${data.msg} — ${legs.join(", ")}`;
    };

    /**
     * Forces a reprocess of every Sansay/ROME record on this order that is still
     * in "Needs Review". Ignores the one hour wait and the automatic attempt cap.
     */
    const handleReprocessSansayRome = async (e) => {
        e.preventDefault();
        if (reprocessing) return;

        const confirmed = window.confirm(
            "Reprocess all Sansay/ROME records currently in Needs Review for this order?"
        );
        if (!confirmed) return;

        try {
            setReprocessing(true);
            incrementLoading();
            const response = await axiosJWT.post(
                `${baseUrl}/reprocess-sansay-rome/${atob(id)}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setIsSuccess(response.data.status);
            setMsg(buildReprocessMessage(response.data));
            getOrderDetail(0);
        } catch (error) {
            setIsSuccess(false);
            setMsg(error?.response?.data?.msg || "Reprocess failed, please try again");
        } finally {
            setReprocessing(false);
            decrementLoading();
        }
    };

    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });


    const handleExportCSV = async (exportOrders) => {
        // e.preventDefault();
        // console.log(exportOrders)

        const headerRow = ["Tel Number"];

        if (detail.order_type === 4 || detail.order_type == 5) {
            headerRow.push('Overall Status')
            { role <= 2 && headerRow.push('Alias') }
            { role <= 2 && headerRow.push('Origination ANI') }
            { role <= 2 && headerRow.push('Match Length') }
            { role <= 2 && headerRow.push('Origination DNIS') }
            { role <= 2 && headerRow.push('Match Length') }
            { role <= 2 && headerRow.push('Translated ANI') }
            { role <= 2 && headerRow.push('Translated DNIS') }
            { role <= 2 && headerRow.push('ANI Action') }
            { role <= 2 && headerRow.push('DNIS Action') }

            const csv = [headerRow].concat(
                exportOrders.map((order, index) => {
                    console.log(order)
                    const tn_number = order.tn_number;
                    let resultArray = [tn_number];
                    resultArray.push(order.user_status == 2 ? "Failed" : (order.user_status == 1 ? "Complete" : "In Progress"));
                    resultArray.push(order.alias)
                    resultArray.push(order.original_ani)
                    resultArray.push(`${order.ani_min_length}-${order.ani_max_length}`)
                    resultArray.push(order.original_dnis)
                    resultArray.push(`${order.dnis_min_length}-${order.dnis_max_length}`)
                    resultArray.push(order.translated_ani)
                    resultArray.push(order.translated_dnis)
                    resultArray.push(order.ani_action == 0 ? "all" : (order.ani_action == 2 ? "passthrough" : (order.ani_action == 3 ? "prepend" : "match")))
                    resultArray.push(order.dnis_action == 0 ? "all" : (order.dnis_action == 2 ? "passthrough" : (order.dnis_action == 3 ? "noLNP" : (order.dnis_action == 4 ? "prepend" : "match"))))

                    return resultArray.join(',');

                })
            ).join('\n')

            console.log(csv)

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, `order_Detail_${detail.unique_id}.csv`);

        } else {
            { detail.order_type == 0 && headerRow.push('Province') }
            { detail.order_type == 0 && headerRow.push('Rate Center') }
            { detail.order_type != 1 && headerRow.push('Route Option') }
            { role <= 2 && headerRow.push('Carrier') }
            { headerRow.push('CNAM') }
            { role <= 2 && headerRow.push('E911') }
            { role <= 2 && headerRow.push('Sansay') }
            { role <= 2 && headerRow.push('ROME') }
            { role <= 2 && (detail.order_type == 0 || detail?.order_type == 2 || detail?.order_type == 9) && headerRow.push('Carrier Status') }
            headerRow.push('Overall Status')

            const csv = [headerRow].concat(
                exportOrders.map((order, index) => {
                    const tn_number = order.tn_number;
                    const route_option = order.route_option;
                    let resultArray = [tn_number];
                    if (detail.order_type == 0) {
                        resultArray.push(order.province);
                        resultArray.push(order.rate_center);
                    }
                    if (detail.order_type != 1) {
                        resultArray.push(`"${order.route_option}"`);
                    }
                    if (role <= 2) {
                        resultArray.push(getCarrierName(order, detail));
                    }
                    resultArray.push(getCNAMStatus(order));
                    if (role <= 2) {
                        resultArray.push(getE911Status(order));
                        resultArray.push(getSansayStatus(order));
                        resultArray.push(getRomeStatus(order));
                    }
                    if (role <= 2 && (detail.order_type == 0 || detail?.order_type == 2 || detail.order_type == 9)) {
                        resultArray.push(getCarrierStatus(order));
                    }
                    if (detail.order_type == 0 && order.cname_flag == 1) {
                        resultArray.push((order.cname_status == 2 && order.number_status == 2) ? "Failed" : ((order.cname_status == 1 && order.number_status == 1) ? "Complete" : (((order.cname_status == 2 && order.number_status == 1) || (order.user_status == 1 && order.number_status == 2)) ? "Failed" : "In Progress")));
                    }
                    if (detail.order_type == 0 && order.cname_flag == 0) {
                        resultArray.push(order.user_status == 2 ? "Failed" : (order.user_status == 1 ? "Complete" : "In Progress"));
                    }
                    if (detail.order_type != 0) {
                        resultArray.push(getOverallStatus(order));
                    }
                    return resultArray.join(',');
                })).join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, `order_Detail_${detail.unique_id}.csv`);
        }


    }
    const handleFilterData = (filterData) => {  
        console.log(filterData);      
        const filterList = allNumberList.filter(item => {
            const conditions = [
              // Overall Status: disconnect catches user_status 0+2; new order "Failed" uses number_status==2; "needs_review" uses cname/user logic
              filterData.overallStatus !== undefined && filterData.overallStatus !== null
                ? (filterData.overallStatus == "" ? true
                  : detail.order_type == 2 && (filterData.overallStatus == 0 || filterData.overallStatus == 2) ? (item.user_status == 0 || item.user_status == 2)
                  : filterData.overallStatus == "needs_review" ? (detail.order_type == 0 ? ((item.cname_flag == 1 && item.cname_status == 2 && item.number_status == 1) || (item.cname_flag == 0 && item.user_status == 2 && item.number_status != 2)) : false)
                  : filterData.overallStatus == 2 && detail.order_type == 0 ? item.number_status == 2
                  : item.user_status == filterData.overallStatus)
                : true,
              // Carrier List
              filterData.selectCarrier !== undefined && filterData.selectCarrier !== null ? item.number_type == filterData.selectCarrier : true,
              // Carrier Status: disconnect value=2 = "Needs Review" (number_status 0 or 2 without skip_carrier); value=3 = "Manually Complete" (number_status 3, or disconnect+skip_carrier+number_status 2); disconnect has no "In Progress" records so value=0 returns false
              filterData.numberStatus !== undefined && filterData.numberStatus !== null
                ? (detail.order_type == 2 && filterData.numberStatus == 2 ? (item.number_status == 0 || (item.number_status == 2 && detail.disconnect_skip_carrier != 1))
                  : filterData.numberStatus == 3 ? (item.number_status == 3 || (detail.order_type == 2 && detail.disconnect_skip_carrier == 1 && item.number_status == 2))
                  : detail.order_type == 2 && filterData.numberStatus == 0 ? false
                  : item.number_status == filterData.numberStatus)
                : true,
              // Sansay Status: sansay_status never holds value 3; "Manually Completed" = user_status==3 && sansay_status==2; "Needs Review" = sansay_status==2 && user_status!=3
              filterData.sansayStatus !== undefined && filterData.sansayStatus !== null
                ? (filterData.sansayStatus == 3 ? (item.user_status == 3 && item.sansay_status == 2)
                  : filterData.sansayStatus == 2 ? (item.sansay_status == 2 && item.user_status != 3)
                  : item.sansay_status == filterData.sansayStatus)
                : true,
              // Rome Status: same logic as sansay
              filterData.romeStatus !== undefined && filterData.romeStatus !== null
                ? (filterData.romeStatus == 3 ? (item.user_status == 3 && item.rome_status == 2)
                  : filterData.romeStatus == 2 ? (item.rome_status == 2 && item.user_status != 3)
                  : item.rome_status == filterData.romeStatus)
                : true,
              // Cnam Status: "Manually Completed" = user_status==3 && (cname_status==2 or cname_status==0+cname_flag==1); "Needs Review" = cname_status==2 && user_status!=3; "In Progress" = cname_status==0 && user_status!=3
              filterData.cnameStatus !== undefined && filterData.cnameStatus !== null
                ? (filterData.cnameStatus == 3 ? (item.user_status == 3 && (item.cname_status == 2 || (item.cname_status == 0 && item.cname_flag == 1)))
                  : filterData.cnameStatus == 2 ? (item.cname_status == 2 && item.user_status != 3)
                  : filterData.cnameStatus == 0 ? (item.cname_status == 0 && item.user_status != 3)
                  : item.cname_status == filterData.cnameStatus)
                : true,
              filterData.e911Status !== undefined && filterData.e911Status !== null ? item.e911_status == filterData.e911Status : true
            ];
            
            return conditions.every(condition => condition);
          });
        console.log(filterList);
        setFilteredNumberList(filterList);
        setPage(1); // Reset to the first page after filtering
        
        const limit = 20; // Replace with your actual limit
        const startIndex = (1 - 1) * limit;
        const endIndex = 1 * limit;
        const slicedData = filterList?.slice(startIndex, endIndex);
        setOrders(slicedData);
        setTotalItem(filterList.length);
    }

    const addOrderNumberDmt = async (e) => {
        e.preventDefault();
        const numberList = detail.tn_details.filter(item => {
            const manuallyCompleted = item.user_status === 3;
            const allRequiredFlags = item.user_status === 1 && item.rome_status === 1 && item.sansay_status === 1 && item.number_status === 1;
            const eligible = manuallyCompleted || allRequiredFlags;
            return (item.cname_flag === 1 && eligible && (manuallyCompleted || item.cname_status === 1)) || (item.cname_flag === 0 && eligible);
        });
        if(numberList.length === 0){
            alert("There are no any success number, so not avaialbe for dmt.");
            return;
        }
        // Check which numbers are still active in inventory
        incrementLoading();
        try {
            const tnNumbers = numberList.map(item => item.tn_number);
            const response = await axiosJWT.post(`${baseUrl}/check-active-inventory-numbers`, {
                tnNumbers,
                cid: detail.cid
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const activeNumbers = response.data.activeNumbers || [];
            console.log(activeNumbers, "activeNumbers")
            const activeNumberList = numberList.filter(item => activeNumbers.map(String).includes(String(item.tn_number)));
            console.log(activeNumberList, "activeNumberList");
            console.log(numberList, "numberList")
            if(activeNumberList.length === 0){
                alert("There are no numbers eligible for DMT. All numbers have been cancelled in inventory.");
                return;
            }
            console.log({ state: {compid : detail.cid, successNumberList: activeNumberList, checkAdvanceDigitMapping : checkAdvanceDigitMapping, fromOrder: true, orderId: atob(id)} })
            navigate("/digit-mapping/add-multiple", { state: {compid : detail.cid, successNumberList: activeNumberList, checkAdvanceDigitMapping : checkAdvanceDigitMapping, fromOrder: true, orderId: atob(id)} })
        } catch (error) {
            console.error("Error checking active inventory numbers:", error);
            alert("Failed to check inventory status. Please try again.");
        } finally {
            decrementLoading();
        }
    }

    const getCarrierName = (order, detail) => {
        const number_type = order.number_type;
        const order_type = detail.order_type;
        if(order_type == 7){
            return "Bandwidth/VB";
        }else if(number_type == 1){
            return "Bandwidth";
        }else if(number_type == 0){
            return "Inteliquent";
        }else{
            const name = carriers.find((item) => item.carrier_index == number_type)?.name ?? "-";
            return name;
        }
    }

    const getCNAMStatus = (order) => {
        if(order.user_status === 3 && role <= 2 && order.cname_status == 2) {
            return order.cname_label ? `Manually Completed : ${order.cname_label}` : "Manually Completed";
        } else if(order.user_status === 3 && role > 2 && order.cname_status == 2) {
            return order.cname_label || "Complete";
        } else if(order.user_status === 3 && role <= 2 && order.cname_status == 0 && order.cname_flag == 1) {
            return order.cname_label ? `Manually Completed : ${order.cname_label}` : "Manually Completed";
        } else if(order.user_status === 3 && role > 2 && order.cname_status == 0 && order.cname_flag == 1) {
            return order.cname_label || "Complete";
        } else if(detail.order_type == 2){
            return order.cname_label || "-";
        }else if(order.number_status == 2){
            return "-";
        }else if(order.cname_status == 1){
            return order.cname_label;
        }else if(order.cname_status == 2){
            if(role > 2){
                return order.cname_label ? `In Progress : ${order.cname_label}` : "In Progress";
            }
            return order.cname_label ? `Needs Review : ${order.cname_label}` : "Needs Review"
        }else if(order.cname_status == 0 && order.cname_flag == 1){
            return order.cname_label ? `In Progress : ${order.cname_label}` : "In Progress";
        }else{
            return "-";
        }
    }

    const getE911Status = (order) => {
        if(order.e911_status == 1){
            return "Complete"; 
        }else if(order.e911_status == 2){
            // return "Failed";
            return "Needs Review"
        }else{
            return "-";
        } 
    }

    const getSansayStatus = (order) => {
        // if(order.number_status == 2){
        //     if(detail.order_type == 2){
        //         if(order.sansay_status == 1){
        //             return "Complete";
        //         }else if(order.sansay_status == 2){
        //             return "Needs Review";
        //         }else{
        //             return "-";
        //         }                              
        //     }else{
        //         return "-";
        //     }
        // }else 
        if(order.user_status == 3 && order.sansay_status == 2 && role <= 2){
            return "Manually Completed";
        }else if(order.user_status == 3 && order.sansay_status == 2 && role > 2){
            return "Complete";
        }else if(order.sansay_status == 1){
            return "Complete";
        }else if(order.sansay_status == 2){
            if(detail.order_type == 2){
                return "Needs Review";
            }else{
                // return "Failed";
                return "Needs Review"
            }
            
        }else {
            return "-";
        };
    }

    const getRomeStatus = (order) => {
        // if(order.number_status == 2){
        //     if(detail.order_type == 2){
        //         if(order.rome_status == 1){
        //             return "Complete";
        //         }else if(order.rome_status == 2){
        //             return "Needs Review";
        //         }else{
        //             return "-";
        //         } 
        //     }else{
        //         return "-";
        //     }
        // }else 
        if(order.user_status == 3 && order.rome_status == 2 && role <= 2){
            return "Manually Completed";
        }else if(order.user_status == 3 && order.rome_status == 2 && role > 2){
            return "Complete";
        }else if(order.rome_status == 1){
            return "Complete";
        }else if(order.rome_status == 2){
            if(detail.order_type == 2){
                return "Needs Review";
            }else{
                // return "Failed";
                return "Needs Review"
            }
            
        }else {
            return "-";
        };
    }

    const getCarrierStatus = (order) => {
        if(order.number_status == 2){
            if(detail.order_type == 2 && detail.disconnect_skip_carrier == 1){
                return "Manually Complete";
            }else if(detail.order_type == 2 && detail.disconnect_skip_carrier != 1){
                return "Needs Review";
            }else{
                return "Failed";
            }
        }else if(order.number_status == 1) {
            return "Complete";
        }else if(order.number_status == 3) {
            return "Manually Complete";
        }else if(detail.order_type == 2 && order.number_status == 0){
            return "Needs Review";
        }else{
            return "In Progress";
        }
    }

    const getNewOrderOverallStatus = (order) => {
        // BBD-398: carrier failure (number_status=2) on new order must report overall "Failed"
        if (order.number_status == 2) return "Failed";

        if(order.cname_flag == 1 ){
            if((order.user_status == 3 && role <= 2)) return "Manually Completed"
            if((order.user_status == 3 && role > 2)) return "Complete"
            // A Non-supported Carrier order orders nothing from a carrier, so its rows read
            // number_status 3 ("NA") and never 1. That is finished, so it counts as settled there.
            const carrierSettled = order.number_status == 1 || (detail?.order_type == 6 && order.number_status == 3);
            if (order.cname_status == 1 && carrierSettled) return "Complete";
            if (order.cname_status == 2 && carrierSettled) return "Need Review";
            return "In Progress";
        } else if(order.cname_flag == 0){
            if (order.user_status == 2) return "Need Review";
            if (order.user_status == 1) return "Complete";
            if (order.user_status == 3 && role <= 2) return "Manually Complete";
            if (order.user_status == 3 && role > 2) return "Complete";
            return "In Progress";
        }
        return "In Progress"
    }

    // BBD-416: counts a new order's numbers per bucket so the In Service gate can decide which
    // confirmation to raise. Reuses getNewOrderOverallStatus so the counts always match the
    // Overall Status column the user is looking at. A number still waiting on the carrier webhook
    // is "In Progress"; Needs Review also covers a per-system column (Sansay / ROME / CNAM / E911)
    // reading "Needs Review" while the overall status already says Complete.
    // E911 is deliberately not gated on user_status, because getE911Status is not either - it keeps
    // reporting Needs Review even once the number has been manually completed.
    const getNewOrderStatusBuckets = (numbers) => {
        const buckets = { inProgress: 0, failed: 0, needsReview: 0 };
        (numbers || []).forEach((order) => {
            const overall = getNewOrderOverallStatus(order);
            if (overall === "Failed") {
                buckets.failed += 1;
            } else if (overall === "In Progress") {
                buckets.inProgress += 1;
            } else if (
                overall === "Need Review" ||
                order.e911_status == 2 ||
                (order.user_status != 3 && (order.sansay_status == 2 || order.rome_status == 2 || order.cname_status == 2))
            ) {
                buckets.needsReview += 1;
            }
        });
        return buckets;
    }

    const getOverallStatus = (order) => {
        if(order.user_status == 2){
            if(detail.order_type == 2){
                return "Needs Review";
            }else{
                return "Failed";
            }
        }else if(order.user_status == 1 && (detail.order_type == 8 || detail.order_type == 10)){
            return "Upcoming Port";
        }else if(order.user_status == 4 && (detail.order_type == 8 || detail.order_type == 10)){
            return "Port Successful";
        }else if(order.user_status == 5 && (detail.order_type == 8 || detail.order_type == 10)){
            return "Port Failed";
        }else if(order.user_status == 1){
            return "Complete";
        }else if(order.user_status == 3 && role <= 2){
            return "Manually Completed";
        }else if(order.user_status == 3 && role > 2){
            return "Complete";
        }else if(order.user_status == 0 && detail.order_type == 2 && role <= 2){
            return "Needs Review";
        }else {
            return "In Progress";
        }
    }

    const getPortOutPin = (order) => {
        const pin = order?.port_out_pin;

        if (pin === "-" ) {
          return "Failed";
        }
        if (pin === null || pin === undefined || pin.trim() === "") {
          return "N/A";
        }
        return pin;
    }

    const handleUpdateStatus = async (event) => {
        event.preventDefault();
        console.log(selectedRows, "selectedRows");

        if (!manualStatus) {
            alert('Please select a status.');
            return;
        }
            let msg;
            if(manualStatus == 2){
                msg = "This action will mark the numbers as failed and will take no action with the carrier or Sansay. This cannot be undone. Are you sure you want to proceed?";
            }else{
                msg = "This action will mark the numbers as complete with the carrier and trigger routing updates in the portal. This cannot be undone. Are you sure you want to proceed?";
            }
            const isConfirmed = window.confirm(msg);

            if (isConfirmed) {
                incrementLoading();
                try {
                    const response = await axiosJWT.post(`${baseUrl}/international-order-manual-complete/${atob(id)}`, {selectedNumbers: selectedRows, status: manualStatus}, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });

                    if (response.status === 200) {
                        setMsg("Order status updated successfully.");
                        setIsSuccess(true);
                        getOrderDetail(0); // Refresh data to show updated status and disable switch
                        setSelectedRows([]);
                        setManualStatus(''); // Reset dropdown
                    }
                    decrementLoading();
                } catch (error) {
                    console.error("Failed to update international order status:", error);
                    setMsg(error.response?.data?.msg || "An error occurred while updating the status.");
                    setIsSuccess(false);
                    decrementLoading();
                }
            }
        
    };

    const handleCnamManualComplete = async (event) => {
        event.preventDefault();

        const isConfirmed = window.confirm(
            "This will mark the selected numbers as manually completed and update CNAM in inventory. This cannot be undone. Are you sure?"
        );

        if (isConfirmed) {
            incrementLoading();
            try {
                const response = await axiosJWT.post(
                    `${baseUrl}/cnam-manual-complete/${atob(id)}`,
                    { selectedNumbers: selectedRows },
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.status === 200) {
                    setMsg("Numbers marked as manually completed.");
                    setIsSuccess(true);
                    getOrderDetail(0);
                    setSelectedRows([]);
                }
                decrementLoading();
            } catch (error) {
                console.error("Failed to mark CNAM manual complete:", error);
                setMsg(error.response?.data?.msg || "An error occurred while updating the status.");
                setIsSuccess(false);
                decrementLoading();
            }
        }
    };

    const handleUpdatePortStatus = async (event) => {
        event.preventDefault();
        console.log(selectedRows, "selectedRows");

        if(!portStatus) {
            alert('Please select a port status.');
            return;
        }

        let msg;
        if(portStatus == 1){
            msg = "Please confirm the port of the selected numbers were successful and should now be added to the customer inventory and updated in NSS. Are you sure you want to proceed?";
        }else{
            msg = "This action will remove the selected number(s) from Sansay and set the inventory status to 'Other' (if E-NRMS enabled) or 'Port Failed' (if not E-NRMS enabled). This cannot be undone. Are you sure you want to proceed?";
        }
        const isConfirmed = window.confirm(msg);
        console.log(selectedRows, "selectedRows");
        if (isConfirmed) {
            incrementLoading();
            try {
                await axiosJWT.post(`${baseUrl}/update-port-status/${atob(id)}`, {selectedNumbers: selectedRows,  portStatus: portStatus}, {
                    headers: {  
                        Authorization: `Bearer ${token}`
                    }
                });

                
                    // setMsg("Order status update request has been received.");
                    setIsSuccess(true);
                    getOrderDetail(0); // Refresh data to show updated status and disable switch
                    setSelectedRows([]);
                    setPortStatus(''); // Reset dropdown
                
                decrementLoading();
            } catch (error) {
                console.error("Failed to update international order status:", error);
                setMsg(error.response?.data?.msg || "An error occurred while updating the status.");
                setIsSuccess(false);
                decrementLoading();
            }
        }
    }

  // Handle individual checkbox toggle
  const handleCheckboxChange = (tn_number) => {
    setSelectedRows((prev) =>
      prev.includes(tn_number)
        ? prev.filter((id) => id !== tn_number)
        : [...prev, tn_number]
    );
  };

  // Handle "Select All" checkbox toggle
  const handleSelectAllChange = () => {
    const allNumbers = filteredNumberList || [];
    if (isAllSelected) {
      setSelectedRows([]);
    } else if(detail.order_type === 8){
      setSelectedRows(allNumbers.filter((order) => order.user_status != 4 && order.user_status != 5).map((order) => order.tn_number));
    } else if(detail.order_type === 3){
      // Select all manual pending numbers (unsupported carriers not yet completed)
      setSelectedRows(allNumbers.filter((order) => order.number_type >= 2 && order.user_status !== 3).map((order) => order.tn_number));
    } else {
      setSelectedRows(allNumbers.filter((order) => order.user_status != 1).map((order) => order.tn_number));
    }
  };
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
                <div className="content-page">
                {popupOpen && (
                     <Loader />
                ) }
                {/* BBD-416: In Service confirmation for a new order that still has Failed / Needs Review
                    numbers. Failed numbers require the word YES to be typed so the user has to stop and read. */}
                {statusConfirm && (
                    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div className="common-white-shadow-background setting-section" style={{ maxWidth: '560px', width: '90%', backgroundColor: '#fff', padding: '25px' }}>
                            <h3 style={{ marginBottom: '15px' }}>Confirm Order Status Change</h3>
                            <p style={{ marginBottom: '15px' }}>{statusConfirm.message}</p>
                            <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>{statusConfirm.footer}</p>
                            {statusConfirm.requireTypedYes && (
                                <input
                                    type="text"
                                    value={statusConfirmInput}
                                    onChange={(e) => setStatusConfirmInput(e.target.value)}
                                    placeholder="Type YES"
                                    style={{ marginBottom: '15px', width: '100%' }}
                                />
                            )}
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button
                                    className="search-btn"
                                    style={{ margin: 0 }}
                                    onClick={handleStatusConfirmAccept}
                                    disabled={statusConfirm.requireTypedYes && statusConfirmInput.trim().toUpperCase() !== 'YES'}
                                >
                                    Submit
                                </button>
                                <button
                                    className="search-btn clear-btn"
                                    style={{ width: 'auto', margin: 0 }}
                                    onClick={handleStatusConfirmCancel}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                    <div className="row ">
                    <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>
                        <div className="col-8">
                            <div className="left-title">
                                <h1>Orders Detail</h1>
                            </div>
                        </div>
                        <div className="col-4 inventory-btn">
                            <div className="addnew-button">
                            <Link to="/view-order"><span>&larr;</span> Back</Link>
                                
                                
                            <a className="newrow" onClick={(e) => {getOrderDetail( 1);}} href="#">Export</a>
                            {canReprocessSansayRome && <a className="search" onClick={(e) => handleReprocessSansayRome(e)} href="#">{reprocessing ? 'Reprocessing...' : 'Reprocess Needs Review'}</a>}
                            {digitMapping && userDigitMapping && detail.order_type === 0 && detail.tn_details?.some(item => item.user_status == 1 || item.user_status == 3) && <a className="search" onClick={(e) => addOrderNumberDmt(e)} href="#">Add DMT</a>}
                        
                            </div>
                        </div>
                    </div>
                    <div className="row order-detail">
                        <div className="col-4">
                            <div><strong>Customer Order ID:</strong> {detail?.unique_id}</div>
                            {role <=2 && (detail?.order_type != 7 && detail?.order_type != 1 && detail?.order_type !== 4 && detail?.order_type !== 5) && (detail?.carrier_type == 0 || detail?.carrier_type == 2 || detail?.carrier_type == 3) &&<div><strong>Inteliquent Order Id:</strong> {detail.order_id}</div>}
                            {role <=2 && (detail?.order_type != 1 && detail?.order_type !== 4 && detail?.order_type !== 5) && (detail?.carrier_type == 1 || detail?.carrier_type == 2 || detail?.carrier_type == 3) && <div><strong>Bandwidth Order Id:</strong> {detail.bandwidth_order_id}</div>}  
                            {role <=2 && (detail?.order_type == 0 && detail?.order_type !== 4 && detail?.order_type !== 5) && (orders?.[0]?.cname_label != "")  && (detail.bandwidth_cname_order_id != null) && <div><strong>Bandwidth Cname Order Id:</strong> {detail.bandwidth_cname_order_id}</div>}  
                            {role <=2 && detail?.order_type == 7 &&  <div><strong>Bandwidth/VB Order Id:</strong> {detail.order_id}</div>}  
                            
                        </div>
                        <div className="col-4">
                           {/* <div><strong>Order Type:</strong> {detail?.order_type == 0 ? "New" : (detail?.order_type == 1 ? "Change" :  (detail?.order_type == 2 ? "Disconnect" : (detail?.order_type === 3 ? "Feature" : (detail?.order_type === 4 ? 'New DMT' :(detail?.order_type === 5 ?  'Delete DMT' : (detail?.order_type === 6 ? (role <= 2 ? 'Non-supported Carrier' : 'Manual Order') : detail?.order_type === 7 ? "International New Order" : ""))))))}</div> */}
                           <div><strong>Order Type:</strong>{getOrderTypeLabel(detail?.order_type, role)}</div>                           
                           <div><strong>Order Date ({timeZone}) :</strong> {detail?.created_at ? formatDateTimeToPST(detail?.created_at,timeZone, role) : ''}</div>
                           {(detail?.order_type == 8 || detail?.order_type == 10) && <div><strong>Estimated Port Date: </strong>{detail?.upcoming_port_date ? formatDateTimeToPST(detail?.upcoming_port_date, timeZone, role) : ''}</div>}
                        </div>
                        <div className="col-4">
                        <div><strong>Created By:</strong> {detail?.fname} {detail?.lname}</div>
                           {role <= 2 && detail?.order_type != 8 && detail?.order_type != 10 &&
                            <div className='order-status'>
                                <div><strong>Internal Status :</strong></div>
                                <div><select name="" id="" value={selectedValue} onChange={(e) => changeStatus(e)} >
                                    <option value="">Select Status</option>
                                    {detail?.order_type != 2 && <option value="0" >In Service</option>}
                                    {detail?.order_type != 0 &&<option value="1" >Close</option>}
                                    {!(detail?.order_type == 0 && detail?.order_status == 0) && <option value="2" >Pending</option>}
                                </select></div>
                                <div><a className='order-search' onClick={handleOrderStatusChange}>Save</a></div>
                            </div>
                            }
                            {detail?.order_type == 10 && <div><strong>Internal Status :</strong> Complete</div>}
                            {detail?.order_type != 8 && detail?.order_type != 10 && <div><strong>Status Updated By:</strong> {detail?.internal_status_updated_by}</div>}
                            {detail?.order_type != 8 && detail?.order_type != 10 && <div><strong>Status Updated ({timeZone}):</strong> {detail?.internal_status_updated_at ? formatDateTimeToPST(detail?.internal_status_updated_at, timeZone, role) : ""}</div>}
                        </div>
                        
                    </div>
                    {role <= 2 && detail?.order_type == 2 && <div className='row order-detail'>
                        <div className="col-12">
                        <div><strong>Ignore carrier error and remove number(s) from Sansay, Rome and BAP inventory :</strong> {detail?.disconnect_skip_carrier == 1 ? "ON" : "OFF"}</div>
                        </div>
                    </div>}
                     <div className='common-white-shadow-background setting-section'>
                        <OrderSummaryLog ordertype={detail} summary={orderSummary}  allNumberList={allNumberList} role={role} />
                    </div>
                    
                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <div className="col-md-9">
                                <OrderDetailFilter detail={detail} carriers={carriers} onFilter={handleFilterData} role={role} />
                            </div>
                            <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                {(selectedRows.length > 0 && detail?.order_type === 3 && role <= 2) ? (
                    <div className="boxinput" style={{ gap: '1rem' }}>
                        <div className='export-btn addnew-button'>
                            <a href="#" onClick={handleCnamManualComplete} className='newrow'>Mark Complete</a>
                        </div>
                    </div>
                ) : (selectedRows.length > 0 && detail?.order_type === 8) ? (
                                    <div className="boxinput" style={{ gap: '1rem' }}>
                                        <select name="" id=""  value={portStatus} onChange={(e) => setPortStatus(e.target.value)}>
                                            <option value="">Select Status</option>
                                            <option value="1" >Port Successful</option>
                                            <option value="2" >Port Failed</option>
                                        </select>
                                        <div className='export-btn addnew-button'><a href="#" onClick={handleUpdatePortStatus} className='newrow' >Update Status</a></div>
                                        
                                    </div>
                                ) : (
                                    selectedRows.length > 0 && role <= 2 && detail?.order_type === 7 && (<div className="boxinput" style={{ gap: '1rem' }}>
                                        <select name="" id=""  value={manualStatus} onChange={(e) => { setManualStatus(e.target.value); }}>
                                            <option value="">Select Status</option>
                                            <option value="1" >Complete</option>
                                            <option value="2" >Failed</option>
                                        </select>
                                        <div className='export-btn addnew-button'><a href="#" onClick={(e) => { handleUpdateStatus(e) }} className='newrow' >Update Status</a></div>

                                    </div>)
                                )}
                            </div>
                        </div>
                        <div className="row">
                        <div className=" setting-section haft-whitebox">
                            <div className="search-result-section">
                                <h3></h3>
                                {/* <div className="export-btn newrow"><a className="newrow" href="#">Export</a></div> */}
                            </div>
                                {(detail?.order_type === 4 || detail?.order_type === 5) ?
                                    <table className="tablebox search-result-table">
                                    <thead>
                                    <tr>
                                        <th>Overall Status</th>
                                        <th>Alias</th>
                                        <th>Origination ANI</th>
                                        <th>Match Length</th>
                                        <th>Origination DNIS</th>
                                        <th>Match Length</th>
                                        <th>Translated ANI</th>
                                        <th>Translated DNIS</th>
                                        <th>ANI Action</th>
                                        <th>DNIS Action</th>
                                        {/* <th>Status</th> */}
                                        {/* <th></th>   */}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {orders.map((mapping, index) => (
                                        <tr key={mapping.id}>
                                            <td>{mapping.user_status == 2 ? "Failed" : (mapping.user_status == 1 ? "Complete" : "In Progress")}</td>
                                            <td>{mapping.alias}</td>
                                            <td>{mapping.original_ani}</td>
                                            <td>{mapping.ani_min_length} - {mapping.ani_max_length}</td>
                                            <td>{mapping.original_dnis}</td>
                                            <td>{mapping.dnis_min_length} - {mapping.dnis_max_length}</td>
                                            <td>{mapping.translated_ani}</td>
                                            <td>{mapping.translated_dnis}</td>
                                            <td>{mapping.ani_action == 0 ? "all" : (mapping.ani_action == 2 ? "passthrough" : (mapping.ani_action == 3 ? "prepend" : "match"))}</td>
                                            <td>{mapping.dnis_action == 0 ? "all" : (mapping.dnis_action == 2 ? "passthrough" : (mapping.dnis_action == 3 ? "noLNP" : (mapping.dnis_action == 4 ? "prepend" : "match")))}</td>
                                            {/* <td>{user.role === 1 ? 'Super Admin' : user.role === 2 ? 'Support User' : user.role === 3 ? 'Reseller Admin' : user.role === 4 ? 'Customer admin' :  user.role === 5 ? 'Customer user' : 'Reseller support'}</td> */}
                                            
                                            {/* <td>{user.is_active === 1 ? <a href="#" className="true">True</a> : <a href="#" className="false">False</a> }</td> */}
                                            
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                    :
                                    <table className="tablebox search-result-table">
                                        <thead>
                                            <tr>
                                            {role <= 2 && (detail?.order_type === 7 || detail?.order_type === 8) && (
            <th>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAllChange}
              />
            </th>
          )}
                            {role <= 2 && detail?.order_type === 3 && (
            <th>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAllChange}
              />
            </th>
          )}
                                                <th>Tel Number</th>
                                                {detail?.order_type == 0 && <th>Province</th>}
                                                {detail?.order_type == 0 && <th>Rate Center</th>}
                                                {detail?.order_type != 1 && <th>Route Option</th>}
                                                {role <= 2 && detail?.order_type == 0 && <th>Port Out Pin</th>}
                                                {role <= 2 && <th>Carrier</th>}
                                                <th>CNAM</th>
                                                {role <= 2 && <th>E911</th>}
                                                {role <= 2 && <th>Sansay</th>}
                                                {role <= 2 && <th>ROME</th>}
                                                {role <= 2 && (detail?.order_type == 0 || detail?.order_type == 2 || detail?.order_type == 9) && <th>Carrier Status</th>}
                                                <th>Overall Status</th>





                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orders?.length > 0 && orders.map((order, index) => (

                                                <tr key={index}>
                                                    {role <= 2 && ((detail?.order_type === 7  && order.user_status != 1) || (detail?.order_type === 8 && (order.user_status == 1 || order.user_status == 0))) && (
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(order.tn_number)}
                    onChange={() => handleCheckboxChange(order.tn_number)}
                  />
                </td>
              )}
              {role <= 2 && detail?.order_type === 7 && order.user_status == 1 && <td></td>}
              {role <= 2 && detail?.order_type === 8 && (order.user_status == 4 || order.user_status == 5) && <td></td>}
              {role <= 2 && detail?.order_type === 3 && (
                order.number_type >= 2 && order.user_status !== 3 ? (
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(order.tn_number)}
                      onChange={() => handleCheckboxChange(order.tn_number)}
                    />
                  </td>
                ) : (
                  <td></td>
                )
              )}
                                                    <td>{order.tn_number}</td>
                                                    {detail?.order_type == 0 && <td>{order.province}</td>}
                                                    {detail?.order_type == 0 && <td>{order.rate_center}</td>}
                                                    {detail?.order_type != 1 && <td>{order.route_option}</td>}
                                                    {role <= 2 && detail?.order_type == 0 && <td>{getPortOutPin(order)}</td>}
                                                    {role <= 2 && <td>{getCarrierName(order, detail)}</td>}
                                                    <td>{getCNAMStatus(order)}</td>
                                                    {role <= 2 && <td>{getE911Status(order)}</td>}
                                                    {role <= 2 && <td>{getSansayStatus(order)}</td>}
                                                    {role <= 2 && <td>{getRomeStatus(order)}</td>}
                                                    {role <= 2 && (detail.order_type == 0 || detail?.order_type == 2 || detail?.order_type == 9) && <td>{getCarrierStatus(order)}</td>}
                                                    {/* {detail.order_type == 0 && order.cname_flag == 1 && <td>{(order.cname_status == 2 && order.number_status == 2) ? "Need Review" : ((order.cname_status == 1 && order.number_status == 1) ? "Complete" : (((order.cname_status == 2 && order.number_status == 1) || (order.user_status == 1 && order.number_status == 2)) ? "Need Review" : "In Progress"))}</td>}
                                                    {detail.order_type == 0 && order.cname_flag == 0 && <td>{order.user_status == 2 ? "Need Review" : (order.user_status == 1 ? "Complete" : "In Progress")}</td>} */}
                                                    {detail.order_type == 0 && <td>{getNewOrderOverallStatus(order)}</td>}
                                                    {detail.order_type != 0 && <td>{getOverallStatus(order)}</td>}


                                                    {/* {detail.order_result && detail.order_result['numberType'] !== undefined && 
                                            <>
                                                { role <= 2 && detail.order_result && detail.order_result['numberType'] !== 2  && 
                                                    <td>
                                                        {(role <= 2 && detail.order_result && (detail.order_result['numberType'] === undefined || detail.order_result['numberType'] === 0) && detail.order_result['status']) && (
                                                            <div>
                                                                {detail.order_result['status'].split(/[\[\],]/).map((item, index) => {
                                                                  const trimmedItem = item.trim();
                                                                  if (trimmedItem === 'Error Message:') {
                                                                    return null;
                                                                  }
                                                                  return <p key={index}>{trimmedItem}</p>;
                                                                })}
                                                            </div>
                                                        )}
                                                        {(role <= 2 && detail.order_result && detail.order_result['numberType'] !== undefined && detail.order_result['numberType'] === 1) && (
                                                            <div>{detail.order_result['status']}</div>
                                                        )}
                                                    </td>
                                                }
                                                {role <= 2 && detail.order_result && (detail.order_result['numberType'] == undefined || detail.order_result['numberType'] == 0)  && detail.order_result['result'] && 
                                                    <td>
                                                        {detail.order_result && detail.order_result['result'] && detail.order_result['result'].find((result) =>
                                                            result.includes(order.tn_number.toString())
                                                            ) ? ( 
                                                                detail.order_result['result']
                                                                .find((result) => result.includes(order.tn_number.toString()))
                                                            ) : (       
                                                                detail.order_result['result'] ? <p>Success</p> : ''
                                                            )}
                                                    </td>
                                                }     
                                                {role <= 2  && detail.order_result && (detail.order_result['numberType'] == undefined || detail.order_result['numberType'] == 0 ||  detail.order_result['numberType'] == 1 ) && detail.order_result['sansayResult'] && 
                                                    <td>
                                                        { detail.order_result['sansayResult'][0].response}
                                                    </td>
                                                }                                                    
                                                { detail.order_result &&  detail.order_result['inteliquentAll'] !== undefined && detail.order_result['sansayAll'] !== undefined && ((detail.order_result['order'] !== undefined)  || ((detail.order_result['numberType'] !== undefined) && !detail.order_result['cancel'])) &&
                                                    ((detail.order_result['inteliquentAll'] == 0 &&  detail.order_result['sansayAll'] == true) ? <td>Completed</td> : 
                                                    ((detail.order_result['inteliquentAll'] == 0 &&  detail.order_result['sansayAll'] == false) ? <td>In Progress</td> : 
                                                    ((detail.order_result['inteliquentAll'] == 1 &&  (detail.order_result['sansayAll'] == true || detail.order_result['sansayAll'] == false)) ? <td>In Progress</td> : 
                                                    ((detail.order_result['inteliquentAll'] == 2 &&   detail.order_result['sansayAll'] == false) ? <td>Not Successful</td> : <td></td>))))                                        
                                                }
                                                {detail.order_result &&  (detail.order_result['inteliquentAll'] !== undefined || detail.order_result['bandwidthNumber'] !== undefined) && ((detail.order_result['features'] !== undefined) && (detail.order_result['numberType'] !== undefined)) &&
                                                    ((detail.order_result['inteliquentAll'] == 0 ||  detail.order_result['bandwidthNumber'] == 0) ? <td>Completed</td> : 
                                                    ((detail.order_result['inteliquentAll'] == 0 ||  detail.order_result['bandwidthNumber'] == 0) ? <td>In Progress</td> :  
                                                    ((detail.order_result['inteliquentAll'] == 2 ||   detail.order_result['bandwidthNumber'] == 2) ? <td>Not Successful</td> : <td></td>)))                                        
                                                }
                                                {detail.order_result &&  detail.order_result['inteliquentAll'] !== undefined && detail.order_result['sansayAll'] !== undefined && ((detail.order_result['cancel'] !== undefined)) &&
                                                    ((detail.order_result['inteliquentAll'] == 0) && (detail.order_result['sansayAll'] == true || (detail.order_result['sansayAll'] == false)) ? <td>Cancelled</td> :  
                                                    ((detail.order_result['inteliquentAll'] == 2) && (detail.order_result['sansayAll'] == true || detail.order_result['sansayAll'] == false) ? <td>Not Successful</td> : 
                                                    ((detail.order_result['inteliquentAll'] == 1) && (detail.order_result['sansayAll'] == true || detail.order_result['sansayAll'] == false) && detail.order_result['result'] &&  detail.order_result['result']
                                                    .find((result) => result.includes(order.tn_number.toString())) ? <td>Not Successful</td> : <td>Cancelled</td> ) ) )                                        
                                                }                                                                                
                                            </>
                                        } */}

                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>}
                               
                                {/* <div className="recored-setup"> */}
                                    
                                     {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                    {role <= 2 && detail.order_type != 7 && <div className="common-white-shadow-background setting-section">
                        <div className="search-result-section"><h3>Deleted DMTs</h3></div>
                        <table className="tablebox search-result-table">
                            <thead>
                                <tr>
                                    <th>Alias</th>
                                    <th>Origination ANI</th>
                                    <th>Match Length</th>
                                    <th>Origination DNIS</th>
                                    <th>Match Length</th>
                                    <th>Translated ANI</th>
                                    <th>Translated DNIS</th>
                                    <th>ANI Action</th>
                                    <th>DNIS Action</th>
                                </tr>
                            </thead>
                            {dmtList && dmtList[0]?.delete?.length > 0 && <tbody>
                                {dmtList[0]?.delete.map((mapping, index) => (
                                    <tr key={mapping.id}>
                                        <td>{mapping.alias}</td>
                                        <td>{mapping.original_ani}</td>
                                        <td>{mapping.ani_min_length} - {mapping.ani_max_length}</td>
                                        <td>{mapping.original_dnis}</td>
                                        <td>{mapping.dnis_min_length} - {mapping.dnis_max_length}</td>
                                        <td>{mapping.translated_ani}</td>
                                        <td>{mapping.translated_dnis}</td>
                                        <td>{mapping.ani_action == 0 ? "all" : (mapping.ani_action == 2 ? "passthrough" : (mapping.ani_action == 3 ? "prepend" : "match"))}</td>
                                        <td>{mapping.dnis_action == 0 ? "all" : (mapping.dnis_action == 2 ? "passthrough" : (mapping.dnis_action == 3 ? "noLNP" : (mapping.dnis_action == 4 ? "prepend" : "match")))}</td>
                                    </tr>
                                ))}
                            </tbody>}
                        </table>
                    </div>}
                    {role <= 2 && detail.order_type != 7 && <div className="common-white-shadow-background setting-section">
                        <div className="search-result-section"><h3>DMTs Still Exist in the Sansay</h3></div>
                        <table className="tablebox search-result-table">
                            <thead>
                                <tr>
                                    <th>Alias</th>
                                    <th>Origination ANI</th>
                                    <th>Match Length</th>
                                    <th>Origination DNIS</th>
                                    <th>Match Length</th>
                                    <th>Translated ANI</th>
                                    <th>Translated DNIS</th>
                                    <th>ANI Action</th>
                                    <th>DNIS Action</th>
                                </tr>
                            </thead>
                            {dmtList && dmtList[0]?.pending?.length > 0 && <tbody>
                                {dmtList[0]?.pending.map((mapping, index) => (
                                    <tr key={mapping.id}>
                                        <td>{mapping.alias}</td>
                                        <td>{mapping.original_ani}</td>
                                        <td>{mapping.ani_min_length} - {mapping.ani_max_length}</td>
                                        <td>{mapping.original_dnis}</td>
                                        <td>{mapping.dnis_min_length} - {mapping.dnis_max_length}</td>
                                        <td>{mapping.translated_ani}</td>
                                        <td>{mapping.translated_dnis}</td>
                                        <td>{mapping.ani_action == 0 ? "all" : (mapping.ani_action == 2 ? "passthrough" : (mapping.ani_action == 3 ? "prepend" : "match"))}</td>
                                        <td>{mapping.dnis_action == 0 ? "all" : (mapping.dnis_action == 2 ? "passthrough" : (mapping.dnis_action == 3 ? "noLNP" : (mapping.dnis_action == 4 ? "prepend" : "match")))}</td>
                                    </tr>
                                ))}
                            </tbody>}
                        </table>
                    </div>}
                    {role <= 2 && detail.order_type != 7 && <div className="common-white-shadow-background setting-section">
                        <div className="search-result-section"><h3>DMTs Still Exist in the BAP</h3></div>
                        <table className="tablebox search-result-table">
                            <thead>
                                <tr>
                                    <th>Alias</th>
                                    <th>Origination ANI</th>
                                    <th>Match Length</th>
                                    <th>Origination DNIS</th>
                                    <th>Match Length</th>
                                    <th>Translated ANI</th>
                                    <th>Translated DNIS</th>
                                    <th>ANI Action</th>
                                    <th>DNIS Action</th>
                                </tr>
                            </thead>
                            {dmtList && dmtList[0]?.portal?.length > 0 &&<tbody>
                                {dmtList[0]?.portal.map((mapping, index) => (
                                    <tr key={mapping.id}>
                                        <td>{mapping.alias}</td>
                                        <td>{mapping.original_ani}</td>
                                        <td>{mapping.ani_min_length} - {mapping.ani_max_length}</td>
                                        <td>{mapping.original_dnis}</td>
                                        <td>{mapping.dnis_min_length} - {mapping.dnis_max_length}</td>
                                        <td>{mapping.translated_ani}</td>
                                        <td>{mapping.translated_dnis}</td>
                                        <td>{mapping.ani_action == 0 ? "all" : (mapping.ani_action == 2 ? "passthrough" : (mapping.ani_action == 3 ? "prepend" : "match"))}</td>
                                        <td>{mapping.dnis_action == 0 ? "all" : (mapping.dnis_action == 2 ? "passthrough" : (mapping.dnis_action == 3 ? "noLNP" : (mapping.dnis_action == 4 ? "prepend" : "match")))}</td>
                                    </tr>
                                ))}
                            </tbody>}
                        </table>
                    </div>}
                    {role <= 2 && 
                        <OrderDetailLog detail={detail} token={token}  />
                    }
                    {/* {role <= 2 && detail.order_type == 1 && <OrderDetailLog detail={detail}  />} */}
                    {/* {role <= 2 &&  detail.order_result && detail.order_result['carrierType'] == undefined &&  
                        detail.order_result['numberType'] !== 2 ? 
                            (
                                <div className="row order-detail">
                                    {detail.order_result ? (
                                        <>
                                            <div className="col-6">
                                                <div className="stauts-table">
                                                    {(detail.order_result['numberType'] !== undefined && detail.order_result['numberType'] === 1) ? <strong>Bandwidth Response: </strong>  : <strong>Carrier Response: </strong>  }

                                                    <div className={`${
                                                        detail.order_result?.['status'] &&
                                                        detail.order_result['status']
                                                        .split(/[\[\],]/)
                                                        .filter(item => item.trim() !== 'Error Message:' && item.trim() !== '')
                                                        .length > 1
                                                        ? 'status-value status-tag'
                                                        : 'status-tag'
                                                    }`}>
                                                    {detail.order_result?.['status'] && detail.order_result['status'].split(/[\[\],]/).map((item, index) => {
                                                            const trimmedItem = item.trim();
                                                            if (trimmedItem === 'Error Message:') {

                                                                return null;
                                                            }
                                                        return <p key={index}> {trimmedItem}</p>;
                                                    })}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                {(detail.order_result['numberType'] == undefined || detail.order_result['numberType'] === 0) && <div><strong>Carrier Status Code:</strong> {detail.order_result['statusCode']}</div>}
                                            </div>
                                            {detail.order_result['sansayResult'] && (
                                                <div className="col-6">
                                                    {detail.order_result['sansayResult'].map((item, index) => (
                                                      <div key={index}>
                                                        <strong>Sansay {item.name} Response: </strong>
                                                          {item.response}
                                                      </div>
                                                    ))}
                                                </div>
                                            )}
                                            <div className="col-6">
                                                {detail.order_result['result'] && <div className="stauts-table">
                                                    <strong>Carrier Result:</strong>
                                                    <div className={`${Array.isArray(detail.order_result['result']) && detail.order_result['result'].length > 1 ? 'status-value status-tag' : 'status-tag'}`}>
                                                        {Array.isArray(detail.order_result['result']) ? (
                                                            detail.order_result['result'].map((item, index) => (
                                                                <p key={index}>{item}</p>
                                                            ))
                                                            ) : (
                                                            detail.order_result['result']
                                                        )}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {Object.keys(detail.order_result).map((key) => (
                                                key !== 'bandwidthId' && key !== 'processingStatus' && key !== 'bandwidthNumber' && key !== 'numberType' && key !== 'sansayResult' && key !== 'features' && key !== 'cancel' && key !== 'order' && key != "sansayAll" && key != "inteliquentAll" && key !='orderId' && key != 'status'  && key !='statusCode' && key !='result' && (
                                              <div className="col-6" key={key}>
                                                <strong>{key}:</strong> {detail.order_result[key]}
                                              </div>)
                                            ))}
                                        </>   
                                    ) : (
                                        <>
                                            <div className="col-4">
                                                <div><strong>Carrier Response:</strong> {detail.message}</div>
                                            </div>
                                            <div className="col-4">
                                                <div><strong>Carrier Status Code:</strong> {detail.status_code}</div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                role <= 2 && detail.order_result && detail.order_result['carrierType'] == undefined &&  
                                    <>
                                        <div className="row order-detail">
                                            {detail.order_result && detail.order_result['bandwidthNumber'] !== undefined && ( detail.order_result['bandwidthNumber'] === 0  || detail.order_result['bandwidthNumber'] === 1 || detail.order_result['bandwidthNumber'] === 2) && (<div className="col-6">
                                                <div >
                                                    <div><strong>Bandwidth Order id:</strong> {detail.order_result['bandwidthId']}</div>
                                                </div>
                                                <div >
                                                    <div><strong>Bandwidth Status:</strong> {detail.order_result['processingStatus']}</div>
                                                </div>
                                            </div>)}
                                            {detail.order_result &&  detail.order_result['inteliquentAll'] !== undefined && (detail.order_result['inteliquentAll'] === 0  || detail.order_result['inteliquentAll'] === 1 || detail.order_result['inteliquentAll'] === 2) && (
                                                <div className="col-6">
                                                    <div >
                                                        <div><strong>Carrier Order id:</strong> {detail.order_id}</div>
                                                    </div>
                                                <div >
                                                <div><strong>Carrier Response:</strong> {detail.message}</div>
                                            </div>
                                            <div >
                                                {detail.order_result['result'] && <div className="stauts-table">
                                                    <strong>Carrier Response:</strong>
                                                    <div className={`${Array.isArray(detail.order_result['result']) && detail.order_result['result'].length > 1 ? 'status-value status-tag' : 'status-tag'}`}>
                                                        {Array.isArray(detail.order_result['result']) ? (
                                                            detail.order_result['result'].map((item, index) => (
                                                                <p key={index}>{item}</p>
                                                            ))
                                                            ) : (
                                                            detail.order_result['result']
                                                        )}
                                                        </div>
                                                </div>}
                                            </div>
                                            </div>)}
                                        </div>
                                    </>
                        )
                    }  */}
                </div>
            </div>
        </div>
    )
}
 
export default ViewOrderDetail